/** Плавная прокрутка, если пользователь не просил уменьшить движение в настройках системы. */
export function scrollBehavior(): ScrollBehavior {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}
